export default "__VITE_ASSET__BeODVJj___"